import api from "./index";
import { axios } from "@/utils/request";
import { BaseURL } from "@/utils/config";

export function getListUser(parameter) {
    return axios({
        url: BaseURL + api.User + "list",
        method: "GET",
        params: parameter,
    });
}
export function search(parameter) {
    return axios({
        url: BaseURL + api.User + "search",
        method: "GET",
        params: parameter,
    });
}
export function getListUserCount(parameter) {
    return axios({
        url: BaseURL + api.User + "list_count",
        method: "GET",
        params: parameter,
    });
}
export function createUser(parameter) {
    return axios({
        url: BaseURL + api.User + "create",
        method: "POST",
        data: parameter,
    });
}

export function getProfileUser(parameter) {
    return axios({
        url: BaseURL + api.User + "get_profile_user",
        method: "GET",
        params: parameter,
    });
}

export function updateUser(parameter) {
    return axios({
        url: BaseURL + api.User + "update",
        method: "POST",
        data: parameter,
    });
}
export function banUser(parameter) {
    console.log("ban param");
    console.log(parameter);

    return axios({
        url: BaseURL + api.User + "ban",
        method: "POST",
        data: parameter,
    });
}